import { render, staticRenderFns } from "./queryMarqueTagInput.vue?vue&type=template&id=3a40eae2"
import script from "./queryMarqueTagInput.vue?vue&type=script&lang=js"
export * from "./queryMarqueTagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports